import '../Mitra.css';
import { logo, solutionsVideo } from '../assets/media';

const SERVICES = [
  { title: 'Digital Presence & SEO',   sub: 'WordPress · React · Custom Portals',  price: '€1,000 – 3,000',    accent: 'var(--violet)'    },
  { title: 'Custom Apps & E-Commerce', sub: 'iOS · Android · Shopify · API',        price: '€5,000 – 15,000',   accent: 'var(--cyan)'      },
  { title: 'Enterprise Intelligence',  sub: 'SAP · MS Dynamics · BI · Automation', price: '€25,000 – 50,000+', accent: 'var(--highlight)' },
];

const VALUES = [
  { letter: 'M', word: 'Mastery',      desc: '15+ years enterprise IT'  },
  { letter: 'I', word: 'Integrity',    desc: 'Transparent delivery'     },
  { letter: 'T', word: 'Talent',       desc: 'Curated expert network'   },
  { letter: 'R', word: 'Reliability',  desc: 'On time, on budget'       },
  { letter: 'A', word: 'Adaptability', desc: 'Agile & future-proof'     },
];

function Mitra() {
  return (
    <div className="mitra-page">
      <video ref={el => { if (el) el.playbackRate = 0.5; }} className="page-bg-video" src={solutionsVideo} autoPlay loop muted playsInline />
      <div className="page-bg-overlay"></div>

      <div className="mitra-layout">

        {/* ── Left panel ── */}
        <div className="mitra-left">
          <img src={logo} alt="7 Elemente" className="mitra-logo" />

          <p className="mitra-tag">Strategic IT Consultancy</p>

          <h1 className="mitra-headline">
            Turning digital<br />
            complexity into<br />
            <span className="mitra-hl">clarity.</span>
          </h1>

          <p className="mitra-intro">
            Your technology partner for the German Mittelstand, NGOs &amp; non-technical founders — co-creating scalable solutions that grow with your business.
          </p>

          <div className="mitra-svc-header">
            <div className="mitra-svc-bar" />
            <span className="mitra-svc-label">What We Do &amp; Invest</span>
          </div>

          <ul className="mitra-services">
            {SERVICES.map((s, i) => (
              <li className="mitra-svc-row" key={i} style={{ animationDelay: `${0.1 + i * 0.1}s` }}>
                <span className="mitra-svc-icon" style={{ color: s.accent }}>◆</span>
                <div className="mitra-svc-body">
                  <strong className="mitra-svc-title">{s.title}</strong>
                  <span className="mitra-svc-sub">{s.sub}</span>
                </div>
                <span className="mitra-svc-price" style={{ color: s.accent }}>{s.price}</span>
              </li>
            ))}
          </ul>

          <div className="mitra-contact">
            <span className="mitra-contact-item">info@7Elemente.com</span>
            <span className="mitra-contact-dot">·</span>
            <span className="mitra-contact-phone">+49 5321 39 49 49 6</span>
            <span className="mitra-contact-dot">·</span>
            <span className="mitra-contact-item">www.7elemente.com</span>
          </div>
        </div>

        {/* ── Right panel ── */}
        <div className="mitra-right">
          <div className="mitra-glow" />
          <div className="mitra-quote-bg-mark">"</div>

          <div className="mitra-quote">
            <p className="mitra-quote-text">
              You focus on your business goals — we'll be your <span className="mitra-hl">IT wing.</span>
            </p>
            <div className="mitra-quote-divider" />
            <span className="mitra-quote-author">Our Mission</span>
          </div>

          <div className="mitra-values">
            <div className="mitra-values-header">
              <div className="mitra-values-bar" />
              <span className="mitra-values-label">Our Commitments</span>
            </div>
            {VALUES.map((v, i) => (
              <div className="mitra-value-row" key={v.letter} style={{ animationDelay: `${0.1 + i * 0.08}s` }}>
                <span className="mitra-value-letter">{v.letter}</span>
                <div>
                  <strong className="mitra-value-word">{v.word}</strong>
                  <span className="mitra-value-desc">{v.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default Mitra;
